import {NgModule} from '@angular/core';
import {SidebarComponent} from './sidebar/sidebar.component';
import {RouterModule} from '@angular/router';
import {MainTitleComponent} from './main-title.component';
import {NavigationProgressComponent} from './navigation-progress/navigation-progress.component';
import {CommonModule} from '@angular/common';
import {PageInsideNavigationComponent} from './page-inside-navigation/page-inside-navigation.component';
import {GridModule} from './grid/grid.module';
import {InfoBlockComponent} from './info-block/info-block.component';
import {TagComponent} from './tag/tag.component';
import {PreloaderComponent} from './preloader/preloader.component';
import {CollapseLinkModule} from '@components/collapse-link/collapse-link.module';
import {ButtonComponent} from './button/button.component';
import {SortbyButtonComponent} from './sortby-button/sortby-button.component';
import {LabeledDataComponent} from './labeled-data/labeled-data.component';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {SubheaderComponent} from './subheader/subheader.component';
import {EmptyPagePlaceholderComponent} from './empty-page-placeholder/empty-page-placeholder.component';
import {OnBoardComponent} from './on-board/on-board.component';
import {IconsModule} from '@lab365/icons';

/**
 * Модуль с компонентами для отображения:
 * сайдбар, заголовки, кнопки и т.п.
 */

@NgModule({
    declarations: [
        SidebarComponent,
        MainTitleComponent,
        NavigationProgressComponent,
        PageInsideNavigationComponent,
        InfoBlockComponent,
        TagComponent,
        PreloaderComponent,
        ButtonComponent,
        SortbyButtonComponent,
        LabeledDataComponent,
        SubheaderComponent,
        EmptyPagePlaceholderComponent,
        OnBoardComponent,
    ],
    exports: [
        SidebarComponent,
        MainTitleComponent,
        NavigationProgressComponent,
        PageInsideNavigationComponent,
        GridModule,
        InfoBlockComponent,
        TagComponent,
        PreloaderComponent,
        CollapseLinkModule,
        ButtonComponent,
        SortbyButtonComponent,
        LabeledDataComponent,
        SubheaderComponent,
        EmptyPagePlaceholderComponent,
        OnBoardComponent,
    ],
    imports: [
        GridModule,
        RouterModule,
        CommonModule,
        CollapseLinkModule,
        DirectivesModule,
        IconsModule,
    ],
    entryComponents: [
    ],
    providers: [
    ]
})
export class LayoutModule {

}
